import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { logError } from '../utils/logging';
import { debounce } from 'tiny-throttle';

let currentHeight = 450;

export default styled(({ children, heightChanged, className }) => {
  const contentRef = useRef(null);
  useEffect(() => {
    if (!contentRef) {
      return;
    }
    try {
      // eslint-disable-next-line
      function callback() {
        const height =
          contentRef &&
          contentRef.current &&
          contentRef.current.offsetHeight + 20;

        if (Math.abs(height - currentHeight) > 20) {
          heightChanged(height);
          currentHeight = height;
        }
      }
      const observer = new MutationObserver(debounce(callback, 100));
      observer.observe(contentRef.current, {
        childList: true,
        subtree: true,
      });
      callback();
      return () => observer.disconnect();
    } catch (error) {
      logError('Failed to setup content observer', error);
    }
  }, [heightChanged, contentRef]);
  return (
    <div className={className} ref={contentRef}>
      {children}
    </div>
  );
})`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 8px 8px 0 8px;
`;
